import type LayoutConfig from "./LayoutConfigTypes";

const DefaultThemeConfig: LayoutConfig = {
  name: "Start",
  version: "v1.1.0",
  fullName: "studio.mycrogym.com",
  general: {
    iconsType: "duotone",
  },
  loader: {
    display: true,
    type: "spinner-logo",
  },
  scrollTop: {
    display: true,
  },
  header: {
    display: true,
    width: "fixed",
    fixed: {
      desktop: true,
      tabletAndMobile: true,
    },
  },
  megaMenu: {
    display: true,
  },
  aside: {
    display: true,
    fixed: true,
    menu: "main",
    primaryDisplay: true,
    secondaryDisplay: true,
    toggle: true,
    minimized: false,
  },
  content: {
    width: "fluid",
  },
  toolbar: {
    display: false,
    width: "fixed",
    breadcrumb: true,
  },
  sidebar: {
    display: true,
    toggle: true,
    shown: true,
    content: "general",
    bgColor: "bg-info",
    displayFooter: true,
    displayFooterButton: true,
  },
  footer: {
    width: "fixed",
  },
  illustrations: {
    set: "sigma-1",
  },
};

export default DefaultThemeConfig;
